import styled from 'styled-components'
import ReactPlayer from 'react-player'
import { Typography } from '@material-ui/core'
import { Button } from '../../../../components/button/button'
import { Maybe } from '../../../../gql'

interface ImageWrapperContainerProps {
  vectorRightSrc?: string | null
  vectorLeftSrc?: string | null
}

export const Background = styled.div`
  background: none;
`

export const Wrapper = styled.div`
  width: 100%;
  margin-top: 0;
  position: relative;
  z-index: 1;
  clip-path: polygon(0 0, 100% 0, 100% ${props => props.theme.typography.pxToRem(540)}, 0 100%);
  height: 568px;
  display: flex;
  background: linear-gradient(90deg, #E37025 0%, #EBA719 100%) no-repeat left top;
  background-size: cover;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: url('/images/home_banner_bottom_left_ol.svg');
    background-repeat: no-repeat;
    background-color: transparent;
    width: 50%;
    height: 50%;
    opacity: 0.8;
    background-position: left bottom;
    background-size: contain;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    background-image: url('/images/home_banner_top_right_ol.svg');
    background-repeat: no-repeat;
    background-color: transparent;
    width: 50%;
    height: 50%;
    opacity: 0.75;
    background-position: right top;
    background-size: contain;
  }

  ${props => props.theme.breakpoints.up('sm')} {
      clip-path: polygon(0 0, 100% 0, 100% 540px, 0 100%);
      height: 500px;
  }

  ${props => props.theme.breakpoints.up('lg')} {
    clip-path: polygon(0 0, 100% 0, 100% ${props => props.theme.typography.pxToRem(675)}, 0 100%);
    height: ${props => props.theme.typography.pxToRem(756)};

    &::before {
      width: 30%;
      height: 80%;
    }

    &::after {
      width: 25%;
      height: 60%;
    }
  }
`

export const TextContainer = styled.div`
  position: relative;
  margin-top: ${props => props.theme.typography.pxToRem(75)};
  margin-right: ${props => props.theme.typography.pxToRem(30)};
  margin-left: ${props => props.theme.typography.pxToRem(30)};
  width: calc(100% - ${props => props.theme.typography.pxToRem(60)});
  display: flex;
  flex-direction: column;
  z-index: 50;
  align-items: flex-start;

  ${props => props.theme.breakpoints.up('sm')} {
      margin-top: ${props => props.theme.typography.pxToRem(108)};
  }

  ${props => props.theme.breakpoints.up('md')} {
      padding-right: ${props => props.theme.typography.pxToRem(54)};
      padding-left: ${props => props.theme.typography.pxToRem(54)};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${props => props.theme.typography.pxToRem(275)};
    max-width: ${props => props.theme.typography.pxToRem(1250)};;
    margin-top: ${props => props.theme.typography.pxToRem(200)};
    width: 100%;
    align-items: baseline;
  }
`

type LargeFontType = {
  $largeFont?: Maybe<boolean> | undefined
}

export const Heading = styled(Typography) <LargeFontType>`
  color: white;
  font-style: italic;
  font-size: ${props => props.$largeFont ? props.theme.typography.pxToRem(33) : props.theme.typography.pxToRem(30)};
  margin-bottom: ${props => props.$largeFont ? props.theme.typography.pxToRem(20) : props.theme.typography.pxToRem(17)};
  text-align: left;
  line-height: ${props => props.$largeFont ? props.theme.typography.pxToRem(38) : props.theme.typography.pxToRem(36)};
  text-shadow: 0 0 ${props => props.theme.typography.pxToRem(16)} rgba(0, 0, 0, 0.25);
  max-width: 80%;

  ${props => props.theme.breakpoints.up('sm')} {
      max-width: 50%;
  }

  ${props => props.theme.breakpoints.up(768)} {
      font-size: ${props => props.$largeFont ? props.theme.typography.pxToRem(40) : props.theme.typography.pxToRem(36)};
      line-height: ${props => props.$largeFont ? props.theme.typography.pxToRem(55) : props.theme.typography.pxToRem(42)};
  }  

  ${props => props.theme.breakpoints.up('md')} {
      margin-bottom: ${props => props.$largeFont ? props.theme.typography.pxToRem(18) : props.theme.typography.pxToRem(30)};
  }

  ${props => props.theme.breakpoints.up('lg')} {
    text-align: left;
    font-weight: 700;
    font-style: italic;
    max-width: ${props => props.theme.typography.pxToRem(558)};
    margin-bottom: ${props => props.theme.typography.pxToRem(25)};
    font-size: ${props => props.$largeFont ? props.theme.typography.pxToRem(55) : props.theme.typography.pxToRem(48)};
    line-height: ${props => props.$largeFont ? props.theme.typography.pxToRem(60) : props.theme.typography.pxToRem(55)};
  }
`

export const Subtext = styled(Typography) <LargeFontType>`
  color: white;
  margin-bottom: ${props => props.theme.typography.pxToRem(22)};
  font-size: ${props => props.$largeFont ? props.theme.typography.pxToRem(22) : props.theme.typography.pxToRem(16)};
  text-align: left;
  max-width: ${props => props.theme.typography.pxToRem(290)};
  line-height: ${props => props.theme.typography.pxToRem(22)};
  text-shadow: 0 0 ${props => props.theme.typography.pxToRem(16)} rgba(0, 0, 0, 0.25);
  font-weight: 500;

  ${props => props.theme.breakpoints.up('sm')} {
    max-width: ${props => props.theme.typography.pxToRem(558)};
  }

  ${props => props.theme.breakpoints.up('md')} {
    line-height: ${props => props.theme.typography.pxToRem(35)};
    font-size: ${props => props.$largeFont ? props.theme.typography.pxToRem(28) : props.theme.typography.pxToRem(22)};
    text-align: left;
  }
`

export const StyledButton = styled(Button) <LargeFontType>`
  font-size: ${props => props.theme.typography.pxToRem(17)};
  padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(30)};
  border-radius: 4px;
  background-color: #CC2605;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: ${props => props.theme.typography.pxToRem(18)};
    padding: ${props => props.theme.typography.pxToRem(16)} ${props => props.theme.typography.pxToRem(30)};
  }
    
  &:hover {
      background-color: #CC2605;
  }
`

export const VideoBannerWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% ${props => props.theme.typography.pxToRem(360)}, 0 100%);
  height: 568px;

  ${props => props.theme.breakpoints.up('lg')} {
    height: ${props => props.theme.typography.pxToRem(640)};
    clip-path: polygon(0 0, 100% 0, 100% ${props => props.theme.typography.pxToRem(441)}, 0 100%);
  }
`

export const ImageWrapperContainer = styled.div`
    position: relative;
    width: 100%;
`

// @ts-ignore
export const ImageWrapperContainerInner = styled('div', {shouldForwardProp: (prop) => prop !== 'vectorRightSrc' && prop !== 'vectorLeftSrc'})<ImageWrapperContainerProps>`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    
    ${props => props.theme.breakpoints.up('lg')} {
        width: 1280px;
    }

    ${props => props.theme.breakpoints.up(1500)} {
        width: 1500px;
    }

    ${props => props.theme.breakpoints.up(1700)} {
        width: 1600px;
    }

    ${props => props.theme.breakpoints.up(1800)} {
        width: 1700px;
    }

    ${props => props.theme.breakpoints.up(1920)} {
        width: 1920px;
    }
    
    &:before,
    &:after {
        content: '';
        position: absolute;
        bottom: 100px;
        width: ${props => props.theme.typography.pxToRem(280)};;
        height: ${props => props.theme.typography.pxToRem(130)};;
        background-repeat: no-repeat;
        background-size: contain;
        display: none;

        ${props => props.theme.breakpoints.up('lg')} {
            display: flex;
        }

        ${props => props.theme.breakpoints.up('xl')} {
            width: ${props => props.theme.typography.pxToRem(330)};;
            height: ${props => props.theme.typography.pxToRem(150)};;
        }
    }
    
    &:before {
        left: 0;
        background-image: ${({ vectorLeftSrc }) => vectorLeftSrc ? `url(${vectorLeftSrc})` : 'none'};
        bottom: ${props => props.theme.typography.pxToRem(10)};
        transform: rotate(-2deg);

        ${props => props.theme.breakpoints.between(1300, 1400)} {
            left: -2%;
        }

        ${props => props.theme.breakpoints.between(1400, 1500)} {
            left: -6%;
        }

        ${props => props.theme.breakpoints.between(1500, 1600)} {
            left: -1%;
        }
        
        ${props => props.theme.breakpoints.up(2500)} {
            left: 0;
            bottom: ${props => props.theme.typography.pxToRem(14)};
        }

        ${props => props.theme.breakpoints.up(3000)} {
            bottom: ${props => props.theme.typography.pxToRem(15)};
        }

        ${props => props.theme.breakpoints.up(3500)} {
            bottom: ${props => props.theme.typography.pxToRem(24)};
            transform: rotate(-1.4deg);
        }
    }
    
    &:after {
        right: 0;
        background-image: ${({ vectorRightSrc }) => vectorRightSrc ? `url(${vectorRightSrc})` : 'none'};
        transform: rotate(-2.3deg);
        bottom: ${props => props.theme.typography.pxToRem(72)};

        ${props => props.theme.breakpoints.up(1920)} {
            right: ${props => props.theme.typography.pxToRem(30)};
        }

        ${props => props.theme.breakpoints.up(2500)} {
            transform: rotate(-2deg);
            bottom: ${props => props.theme.typography.pxToRem(65)};
        }

        ${props => props.theme.breakpoints.up(3000)} {
            transform: rotate(-1.8deg);
            bottom: ${props => props.theme.typography.pxToRem(62)};
        }

        ${props => props.theme.breakpoints.up(3500)} {
            transform: rotate(-1.5deg);
            bottom: ${props => props.theme.typography.pxToRem(55)};
        }
    }
`



export const ImageContainer = styled.div`
  width: 100%;
  height: 435px;
  position: absolute;
    z-index: -1;
    bottom: ${props => props.theme.typography.pxToRem(145)};

  ${props => props.theme.breakpoints.up('lg')} {
     bottom: ${props => props.theme.typography.pxToRem(55)}; 
  }  
    
  ${props => props.theme.breakpoints.up('lg')} {
    max-width: ${props => props.theme.typography.pxToRem(1920)};
    display: flex;
    justify-content: flex-end;
    height: ${props => props.theme.typography.pxToRem(775)};
  }
  
  img {
      z-index: 30;
  }

  & > img {
    width: auto !important;
    left: auto !important;
    right: 2% !important;
  }
`

export const StyledReactPlayer = styled(ReactPlayer)`
  position: relative;

  & > div {
    position: absolute;
    top: -70px;
  }

`

export const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  max-width: 100%;
  height: ${props => props.theme.typography.pxToRem(640)};
  display: none;

  ${props => props.theme.breakpoints.up('lg')} {
    display: block;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.1;
    width: 33%;
    height: 100%;
  }

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    clip-path: inset(1px 1px);
    pointer-events: none;
  }

  ${StyledReactPlayer} {
    position: absolute;
    top: 0;
  }
`

export const MobileBannerVector = styled.div`
    width: ${props => props.theme.typography.pxToRem(148)};
    height: ${props => props.theme.typography.pxToRem(75)};
    position: absolute;
    bottom: ${props => props.theme.typography.pxToRem(5)};
    display: flex;
    align-items: flex-start;
    left: 10%;
    z-index: 20;

    ${props => props.theme.breakpoints.up(500)} {
        left: 25%;
    }

    ${props => props.theme.breakpoints.up('sm')} {
        bottom: ${props => props.theme.typography.pxToRem(5)};
        left: 43%;
    }

    ${props => props.theme.breakpoints.up(768)} {
        left: 47%;
        width: ${props => props.theme.typography.pxToRem(170)};
        height: ${props => props.theme.typography.pxToRem(90)};
    }

    ${props => props.theme.breakpoints.up('md')} {
        left: 58%;
    }
`